// extracted by mini-css-extract-plugin
export default {"external":"afhvTq","tabRoot":"bfhvTq","tabTime":"cfhvTq","tabTimeCommon":"dfhvTq","tabTimeActive":"efhvTq","tabTimeDisabled":"ffhvTq"};